module.exports = {
    processSectionFormulas: function (editing = false) {
        let $dips = $('.create-update-fields').find('.data-input[data-type="formula"]');

        if(formulaOrderEnabledTenant()){
            $dips = $('.create-update-fields').find('.data-input[data-type="formula"]').sort(function(a, b) {
                return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
            });
        }

        let payload = [];

        if ($dips.length) {
            $($dips).each(function (i, $dip) {
                let id = $($dip).data('id'),
                    action = $($dip).data('action'),
                    table_id = '',
                    record_id = '',
                    data = {};

                if (action === 'edit') {
                    table_id = $($dip).data('table-id');
                    record_id = $($dip).data('record-id');
                }
                if ($($dip).attr('data-sum-holders')) {
                    let sum_holder = JSON.parse($($dip).attr('data-sum-holders'));

                    if (sum_holder.length) {
                        $(sum_holder).each(function (i, holder) {
                            let $containers = $('.browse-table').find('td[data-field="' + holder + '"]');

                            $containers.each(function (index, $container) {
                                let table = $($container).parents('.browse-table').attr('data-table-id'),
                                    row_id = $($container).parents('.edit-hover').attr('data-col');

                                let value = 0;

                                if ($($container).hasClass('browse-formula')) {
                                    value = $($container).text().trim();
                                }

                                if ($($container).attr('data-field-type') === 'relationship') {
                                    value = $($container).attr('data-value');
                                }

                                if (
                                    $($container).attr('data-field-type') === 'number' ||
                                    $($container).attr('data-field-type') === 'decimal' ||
                                    $($container).attr('data-field-type') === 'currency'
                                ) {
                                    value = $($container).attr('data-value');
                                }

                                if ($($container).find('.custom-value-edit').length) {
                                    value = $($container).find('.custom-value-edit').val();
                                }
                                data[`${table}_${row_id}_${holder}`] = value;
                            });
                        });
                    }
                }

                if ($($dip).attr('data-holders')) {
                    let holders = JSON.parse($($dip).attr('data-holders'));
                    if (holders.length) {
                        $(holders).each(function (i, holder) {
                            data[holder] = $('.data-input[name="' + holder + '"]').val();
                        });
                    }
                }

                payload.push({
                    id,
                    data,
                    action,
                    table_id,
                    record_id,
                    editing
                })
            });

            payload = JSON.stringify(payload);

            $.ajax({
                type: 'GET',
                url: '/parse_formula/section',
                data: {
                    payload
                },
                success: function (data) {
                    Object.keys(data).forEach(function (key) {
                        if (data[key] !== 'invalid') {
                            let $dip = $('.create-update-fields').find(`.data-input[data-id="${key}"]`)
                            if (!$($dip).attr('data-old-value')) {
                                let old_val = $($dip).val();
                                $($dip).attr('data-old-value', old_val).addClass('section-formula-update');
                            }
                            $($dip).val(data[key]);
                            $($dip).closest('.form-group').addClass('control-highlight');
                        }
                    });
                }
            })
        }
    },

    executeFormulas: function () {
        let $dips = $('.data-input[data-type="formula"]');

        if(formulaOrderEnabledTenant()){
            $dips = $('.data-input[data-type="formula"]').sort(function(a, b) {
                return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
            });
        }

        let payload = [];
        if ($dips.length) {
            $($dips).each(function (i, $dip) {
                let holders = JSON.parse($($dip).attr('data-holders')),
                    id = $($dip).data('id'),
                    action = $($dip).data('action'),
                    table_id = '',
                    record_id = '',
                    data = {};

                if (action === 'edit') {
                    table_id = $($dip).data('table-id');
                    record_id = $($dip).data('record-id');
                }

                if ($($dip).attr('data-sum-holders')) {
                    let sum_holder = JSON.parse($($dip).attr('data-sum-holders'));

                    if (sum_holder.length) {
                        $(sum_holder).each(function (i, holder) {
                            let $containers = $('.browse-table').find('td[data-field="' + holder + '"]');

                            $containers.each(function (index, $container) {
                                let table = $($container).parents('.browse-table').attr('data-table-id'),
                                    row_id = $($container).parents('.edit-hover').attr('data-col');

                                let value = 0;

                                if ($($container).hasClass('browse-formula')) {
                                    value = $($container).text().trim();
                                }

                                if ($($container).attr('data-field-type') === 'relationship') {
                                    value = $($container).attr('data-value');
                                }

                                if (
                                    $($container).attr('data-field-type') === 'number' ||
                                    $($container).attr('data-field-type') === 'decimal' ||
                                    $($container).attr('data-field-type') === 'currency'
                                ) {
                                    value = $($container).attr('data-value');
                                }

                                if ($($container).find('.custom-value-edit').length) {
                                    value = $($container).find('.custom-value-edit').val();
                                }
                                data[`${table}_${row_id}_${holder}`] = value;
                            });
                        });
                    }
                }

                if (holders.length) {
                    $(holders).each(function (i, holder) {
                        data[holder] = $('.data-input[name="' + holder + '"]').val();
                    });

                    payload.push({
                        id,
                        data,
                        action,
                        table_id,
                        record_id
                    });
                }
            });

            if (payload.length) {
                payload = JSON.stringify(payload);
                $.ajax({
                    type: 'GET',
                    url: '/parse_formula',
                    data: {
                        payload
                    },
                    success: function (data) {
                        Object.keys(data).forEach(function (key) {
                            if (data[key] !== 'invalid') {
                                let $dip = $(`.data-input[data-type="formula"][data-id="${key}"]`);
                                $($dip).val(data[key]);
                                $($dip).closest('.form-group').addClass('control-highlight');
                            }
                        });
                    }
                })
            }
        }
    },

    evaluateSectionPlaceholders : function ($container){
        let $dips = $($container).find('.data-input[data-type="formula"]');
        let payload = [];

        if(formulaOrderEnabledTenant()){
            $dips = $($container).find('.data-input[data-type="formula"]').sort(function(a, b) {
                return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
            });
        }

        if ($dips.length) {
            $($dips).each(function (i, $dip) {
                let holders = JSON.parse($($dip).attr('data-holders')),
                    id = $($dip).data('id'),
                    action = $($dip).data('action'),
                    table_id = '',
                    record_id = '',
                    data = {},
                    relations = {},
                    vat_zone = $('.hidden-relation[name="vat_zone"]').val();

                if (action === 'edit') {
                    table_id = $($dip).data('table-id');
                    record_id = $($dip).data('record-id');
                }

                if (holders.length) {
                    $(holders).each(function (i, holder) {
                        data[holder] = $($container).find('.data-input[data-field="' + holder + '"]').val();

                        if (!$($container).find('.data-input[data-field="' + holder + '"]').length) {

                            let $relation_fields = $($container).find('.relation-data-field');

                            $relation_fields.each(function (index, $relation_field) {
                                let $parent = $($relation_field).parents('.editable-td');

                                if ($parent.length) {
                                    let mappings = $parent.attr('data-mappings');

                                    if (mappings.length) {
                                        mappings = JSON.parse(mappings);
                                        mappings.forEach(function (mapping) {
                                            if (mapping[0] === holder.toString()) {
                                                let value = $parent.attr('data-value');
                                                if (value.length) {
                                                    relations[mapping[1]] = [value, mapping[0]];
                                                }
                                            }
                                        });
                                    }
                                }
                            })
                        }
                    });

                    payload.push({
                        id,
                        data,
                        action,
                        table_id,
                        record_id,
                        relations,
                        vat_zone
                    });
                }
            });

            if (payload.length) {
                payload = JSON.stringify(payload);
                $.ajax({
                    type: 'GET',
                    url: '/parse_formula/quick',
                    data: {
                        payload
                    },
                    success: function (data) {
                        Object.keys(data).forEach(function (key) {
                            if (data[key] !== 'invalid') {
                                let $dip = $($container).find(`.data-input[data-type="formula"][data-id="${key}"]`);
                                $($dip).val(data[key]);
                                $($dip).closest('.form-group').addClass('control-highlight');
                            }
                        });
                    }
                })
            }
        }
    }
}